import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { connect } from '../lib/keaConnect'
import Image from '../components/general/util/Image'
import application from '@otavamedia/om-component-library/lib/kea/application'
import auth from '@otavamedia/om-component-library/lib/kea/auth'
import HTML from '@otavamedia/om-component-library/lib/util/HTML'
import { Link } from '../components/general/util/Links'
import BestProductPageLoader from '../components/general/util/BestProductPageLoader'
import { ErrorPlaceholder, withErrorBoundary } from '../components/general/util/ErrorBoundaries'
import TopRowAd from '../components/general/util/TopRowAd'
import TestCard from '../components/widgets/TestCard'
import WP from '@otavamedia/om-component-library/lib/lib/WP'
import RenderedError from '../components/general/util/RenderedError'
import { STATUS } from '@otavamedia/om-component-library/lib/lib/request-state'
import { pushPageDataToGTM, stripHTML } from '@otavamedia/om-component-library/lib/lib/utils'

import './ProductCards.scss'
import { IMAGE_SIZE } from '@otavamedia/om-component-library/lib/entities/ImageModel'
import track from 'react-tracking'

const getPageFromUrl = (link) => {
  const regex = /^(.*\/)([0-9]+)(\/)$/
  return link && parseInt(link.replace(regex, '$2'))
}

@connect({
  actions: [
    application, [
      'setViewData',
    ]
  ],
  props: [
    application, [
      'view',
    ],
    auth, [
      'premiumUser',
    ],
  ]
})
class ProductCards extends Component {
  static propTypes = {
    view: PropTypes.object,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    setRendered: PropTypes.func.isRequired,
    premiumUser: PropTypes.bool,
  }

  state = {
    status: STATUS.NOT_REQUESTED,
    page: getPageFromUrl(window.location.href) || 1,
    tag: 'testipankki',
    articles: [],
    categories: [
      {
        title: 'Kommentoiduimmat',
        categories: ['kommentoiduimmat'],
        noTag: true,
        catIds: [],
        items: [],
        link: null,
        isBest: false
      },
      /*
      {
        title: 'Autot ja moottoripyörät',
        categories: ['autot', 'moottoripyorat', 'polkupyorat', 'renkaat', 'tarvikkeet', 'koeajot'],
        categoryNames: ['Autot', 'Moottoripyörät', 'Polkupyörät', 'Renkaat', 'Lisävarusteet'],
        catIds: [],
        items: [],
        link: '/testit-autot/',
      },
      {
        title: 'Elektroniikka ja teknologia',
        categories: ['mobiililaitteet', 'kamerat', 'televisiot', 'tietotekniikka', 'audio', 'kodintekniikka', 'teknologia', 'testit'],
        categoryNames: ['Mobiililaitteet', 'Kamerat', 'Televisiot', 'Tietotekniikka', 'Audio', 'Kodintekniikka'],
        catIds: [],
        items: [],
        link: '/testit-elektroniikka/',
      },
       */
    ]
  }

  componentDidMount () {
    pushPageDataToGTM({})
    this.loadData()
  }

  componentWillUnmount () {
    this.props.setRendered(false)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.location.key !== this.props.location.key) {
      this.loadData()
    }
  }

  async loadData () {
    try {
      this.getArticles()
      const postReq = await WP.getForURL(WP.url + '/tuotekortit')
      const post = postReq.data
      this.actions.setViewData(post)
    } catch (e) {
      this.setState({
        status: STATUS.ERROR,
        data: e,
      })
    }

    if (this.props.view.id) {
      WP.triggerHitCounter(this.props.view.id)
    }
  }

  async getArticlesForCategories (categories, tag) {
    return WP.getProductCards()
  }

  async getArticles () {
    try {
      this.setState({ status: STATUS.REQUESTED })
      const articles = await this.getArticlesForCategories()
      this.setState({ articles }, () => this.props.setRendered(true))
    } catch (e) {
      console.log(e)
      this.setState({
        status: STATUS.ERROR,
        data: e,
      })
    }
  }

  renderArticles (categories) {
    const { status, articles } = this.state

    const items = <div styleName="item-category">
      <div styleName="item-header">
        <h3>Kommentoiduimmat</h3>
      </div>
      <ul styleName="result-list">
        {articles.map((p, i) => (
          <li styleName="result-item" key={`${i}-${p.id}`}>
            <Link to={p}>
              <TestCard article={p} isBest={false}/>
            </Link>
          </li>
        ))}
      </ul>
    </div>

    const loading = status === STATUS.REQUESTED

    return (
      <Fragment>
        <div data-loading={loading}>
          {items}
        </div>
      </Fragment>
    )
  }

  render () {
    const { status, categories } = this.state
    const { view } = this.props

    if (status !== STATUS.ERROR && (!view || !view.id)) {
      return <BestProductPageLoader />
    }

    const {
      content,
      title,
      excerpt,
      link,
      featuredMedia,
    } = view

    const fullLink = window.location.origin + link
    const metaTags = {
      'og:locale': 'fi_FI',
      'og:type': 'article',
      'og:title': stripHTML(title),
      'og:description': stripHTML(excerpt),
      'og:url': fullLink,
      'http:status': 200,
    }
    return (
      <Fragment>
        <Helmet>
          <title>
            {`${stripHTML(title)} - ${window.om_constants.siteName}`}
          </title>
          <link rel="canonical" href={fullLink} />
          <meta name="description" content={metaTags['og:description']}/>
          {Object.entries(metaTags).map(([key, value], i) => Array.isArray(value)
            ? value.map(x => <meta name={key} key={`${key}-${i}`} content={x} />)
            : <meta name={key} key={`${key}-${i}`} content={value} />
          )}
        </Helmet>
        <div styleName="main-image">
          {featuredMedia
            ? <Image data={featuredMedia} size={IMAGE_SIZE.LARGE} sizes={'(max-width: 1440px) 100vw, 1440px'}/>
            : null
          }
        </div>
        <div styleName='magazine-content'>
          <article styleName="article-container">
            <header>
              <h1><HTML>{title}</HTML></h1>
            </header>
            <div styleName='article-body'>
              <HTML>{content}</HTML>
            </div>
          </article>
          <section styleName="results">
            {status === STATUS.ERROR
              ? <RenderedError error={categories}/>
              : this.renderArticles()
            }
          </section>
        </div>
        <TopRowAd isArticleView={false} display={true}/>
      </Fragment>
    )
  }
}

export default track({ gtmContext: ['ProductCards'] })(withErrorBoundary(
  ProductCards,
  ErrorPlaceholder()
))
